import { useGetAllInvoiceComments } from "@/queries/invoice-comments/get-all";

import { Count } from "@/components/shared/data-table/total-count";

export const CommentsCount = ({
  invoiceId,
  size = "md",
}: { invoiceId: string; size?: "xs" | "sm" | "md" | "lg" }) => {
  const { invoiceComments, loading, error } = useGetAllInvoiceComments({
    invoiceId,
  });

  if (loading || error) return <p className="text-xs">...</p>;

  return <Count count={invoiceComments?.length ?? 0} size={size} noSuccess />;
};
